module.exports = __webpack_public_path__ + "assets/media/purple-arrow.dea5e6f5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/OnboardingPlaybookWoohooStep/ClpWoohoo/purple-arrow.svg
// module id = 3173
// module chunks = 0